import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';

import { Injectable } from '@angular/core';
import { AuthClientConfig, AuthHttpInterceptor } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';
import { environment as env } from 'src/environments/environment';
import { useAuth0Provider } from '../auth-mode';
import { ShopifyJwtInterceptor } from './shopify-jwt-interceptor';

@Injectable()
export class CustomAuthHttpInterceptor implements HttpInterceptor {
  constructor(
    private auth0HttpInterceptor: AuthHttpInterceptor,
    private auth0ClientConfig: AuthClientConfig,
    public shopifyJwtInterceptor: ShopifyJwtInterceptor
  ) {}

  public intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (env.appMode === 'shopify') {
      return this.shopifyJwtInterceptor.intercept(req, next);
    }

    if (useAuth0Provider()) {
      if (!this.auth0ClientConfig.get() && env.auth?.domain && env.auth?.clientId) {
        this.auth0ClientConfig.set({
          domain: env.auth.domain,
          clientId: env.auth.clientId,
          authorizationParams: {
            redirect_uri: env.auth.redirectUri ?? window.location.origin + '/pr1core/',
            ...(env.auth.audience ? { audience: env.auth.audience } : {}),
          },
          httpInterceptor: {
            allowedList: env.httpInterceptor?.allowedList ?? [],
          },
          ...(env.auth.organization ? { organization: env.auth.organization } : {}),
          scope: 'openid profile email',
        });
      }
      return this.auth0HttpInterceptor.intercept(req, next);
    }

    // Keycloak: `KeycloakAngularModule` already registers `KeycloakBearerInterceptor` — pass through.
    return next.handle(req);
  }
}
